import i18n from 'i18next'
import { createAuthHeaders } from '../utils/Authentication'
import { callBackend } from '../utils/BackendCalls'
import { microservices } from '../utils/Microservices'

const searchClauses = (params, page = 1, page_size = 10) => {
  const allowedParams = [
    "value",
    "page",
    "page_size",
    "region",
    "clause_lang",
    "year",
    "deed_type",
    "subsection",
    "fallback_language",
  ]

  const paramsCopy = {
    ...params,
    region: params.deed_land_register_divisions_region,
    page: page,
    page_size: page_size,
    fallback_language: i18n.language,
  }

  if (!['quality', 'bookmarks', 'own_clauses'].includes(paramsCopy.subsection)) {
    delete paramsCopy.subsection
  }

  Object.keys(paramsCopy).forEach((key) => {
    if (!allowedParams.includes(key)) delete paramsCopy[key]
    if (!paramsCopy[key]) delete paramsCopy[key]
  })

  return callBackend(microservices.SEARCH, 'semantic_search', {
    headers: createAuthHeaders(),
    params: paramsCopy,
  })
    .then(result => ({
      clauses: result.documents,
      hasNext: result.has_next,
      amount: result.amount,
    }))
}

const searchModels = (params, page = 1, page_size = 10) => {
  const allowedParams = [
    "value",
    "page",
    "page_size",
    "region",
  ]

  const paramsCopy = {
    ...params,
    page: page,
    page_size: page_size,
  }

  Object.keys(paramsCopy).forEach((key) => {
    if (!allowedParams.includes(key)) delete paramsCopy[key]
    if (!paramsCopy[key]) delete paramsCopy[key]
  })

  return callBackend(microservices.SEARCH, 'search_models', {
    headers: createAuthHeaders(),
    params: paramsCopy,
  })
    .then(data => {
      return {
        ...data,
        hasNext: data.has_next,
        documents: data.documents.map(modifyHTMLStyle)
      }
    })
    .then(result => ({
      models: result.documents,
      hasNext: result.has_next,
      amount: result.amount
    }))
}

const applyHTMLStyle = html => html.replaceAll(
  new RegExp('(p {.*})|(@page {.*})', 'g'),
  '<!-- removed -->'
).replaceAll(
  new RegExp('table width="[0-9]*"', 'g'),
  'table width="100%"'
).replaceAll(
  new RegExp('td width="[0-9]*"', 'g'),
  'td width="50%" style="padding: 5px; border: 1px solid black"'
)

const modifyHTMLStyle = model => ({
  ...model,
  html: applyHTMLStyle(model.html),
  highlight: {
    ...(model.highlight || {}),
    html_highlight: model.highlight && model.highlight.html_highlight
      ? applyHTMLStyle(model.highlight.html_highlight)
      : null
  }
})

const semanticSearchById = (clauseId, page = 1, page_size = 3) => {
  return callBackend(microservices.SEARCH, 'semantic_search_by_id', {
    headers: createAuthHeaders(),
    params: { clauseId: clauseId, page: page, page_size: page_size },
  })
    .then(result => ({
      clauses: result.documents,
      hasNext: result.has_next,
      amount: result.amount,
    }))
}

const semanticSearchByText = (text, page = 1, page_size = 3) => {
  return callBackend(microservices.SEARCH, 'semantic_search_by_text', {
    headers: createAuthHeaders(),
    params: { text: text, page: page, page_size: page_size },
  })
    .then(result => ({
      clauses: result.documents,
      hasNext: result.has_next,
      amount: result.amount,
    }))
}

const getSimilarClauses = (clauseId, page = 1, page_size = 10) => {
  return callBackend(microservices.SEARCH, `clause/${clauseId}/near_duplicates`, {
    headers: { ...createAuthHeaders() },
    params: { page_size: page_size, page: page }
  })
    .then(result => ({
      clauses: result.documents,
      hasNext: result.has_next,
      amount: result.amount,
    }))
}

const getClauseById = clauseId => {
  return callBackend(microservices.SEARCH, `clause/${clauseId}`, {
    headers: { ...createAuthHeaders() },
  })
}

const getDeedById = deedId => {
  return callBackend(microservices.SEARCH, `deed/${deedId}`, {
    headers: { ...createAuthHeaders() },
  })
}

export {
  getClauseById,
  getDeedById,
  getSimilarClauses,
  searchClauses,
  searchModels,
  semanticSearchById,
  semanticSearchByText,
}
